// all keys go in here. do not repeat or re-use keys
// custom, internal, external key, they go in here
// any key assigned to a variable is meant for that variable ONLY.

export const localStorageKey = process.env.REACT_APP_LOCAL_STORAGE_KEY;

export const encryptDecryptKey = process.env.REACT_APP_ENCRYPT_DECRYPT_KEY;

export const privateKey = process.env.REACT_APP_PRIVATE_KEY;

export const publicKey = process.env.REACT_APP_PUBLIC_KEY;

export const wqkgx: any = process.env.REACT_APP_ENCRYPT_KEY;
